const ITEMS = ["Smart Shopping", "Make It Last", "Reduce Waste", "Best Time to Buy", "Store Brand vs Name Brand", "Travel for Less", "Free Alternatives", "Repair Before Replace", "Grocery Habits", "Everyday Tips"];

export const Marquee = () => (
  <div className="marquee overflow-hidden border-y border-ab-border bg-white py-4" aria-hidden="true" data-testid="editorial-marquee">
    <div className="marquee-track">
      {[...ITEMS, ...ITEMS].map((t, i) => (
        <span key={i} className="flex items-center gap-6 pr-6 font-serif text-lg italic text-ab-text-2">
          {t}<span className="h-1.5 w-1.5 rounded-full bg-ab-accent" />
        </span>
      ))}
    </div>
  </div>
);
